/* src/app/shared/components/site-announcement/site-announcement.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.site-announcement {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-height: 3.125rem;
  background-color: #fff59d;
  color: #595555;
  font-size: 0.75rem;
  padding: 0.625rem 1.125rem;
  position: relative;
}
@media screen and (min-width: 48rem) {
  .site-announcement {
    align-items: center;
  }
}
.site-announcement .message {
  width: 100%;
  max-width: 17.1875rem;
  height: 2rem;
  line-height: 1.42;
}
@media screen and (min-width: 48rem) {
  .site-announcement .message {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    max-width: 100%;
  }
}
.site-announcement .message .head-message {
  width: 100%;
  display: inline;
}
@media screen and (min-width: 48rem) {
  .site-announcement .message .head-message {
    width: auto;
    max-width: 29.5625rem;
    margin-right: 0.6875rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.site-announcement .message .message-link {
  cursor: pointer;
  font-weight: 700;
  text-decoration: underline;
  display: inline;
}
.site-announcement .material-icons {
  position: absolute;
  top: 0.9375rem;
  right: 1.0625rem;
  height: 1.25rem;
  width: 1.25rem;
  font-size: 1.25rem;
  cursor: pointer;
}
/*# sourceMappingURL=site-announcement.component.css.map */
